import { useEffect, useState } from 'react';
import { Spinner } from 'components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useKeycloakReady, usePaymentSuccessQuery } from '../../hooks';
import { sessionStorageService } from 'utils/SessionStorageService';
import { useTranslation } from 'react-i18next';
import { useLifePaymentHighProd } from 'all-in-one-shared-api';

export const LifePaymentReturn = () => {
  const navigate = useNavigate();
  const successState = usePaymentSuccessQuery();
  const { token } = useKeycloakReady();
  const [transactionId, setTransactionId] = useState('');
  // const over4 = sessionStorageService.get('over4') === 'true' ? true : false;
  const obj = JSON.parse(sessionStorageService.get('uploadData') ?? '{}');
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const {
    data: payProdData,
    // error,
    shouldFetch: shouldFetchHighProd,
  } = useLifePaymentHighProd('useLifePaymentHighProd' + transactionId, token || '', transactionId);

  useEffect(() => {
    // 直接操作 searchParams 避免中间对象
    if (searchParams.toString()) {
      // 有参数时 toString() 非空
      const paramsObj = Object.fromEntries(searchParams.entries());
      setTransactionId(paramsObj.transactionId);
    }
    shouldFetchHighProd(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
  // useEffect(() => {
  //   if (transactionId)
  // }, [transactionId, token, shouldFetchHighProd]);

  useEffect(() => {
    if (payProdData) {
      console.log(obj, payProdData, successState, '=========================================');
      if (payProdData.paymentMethod == 'fps') {
        if (Number(payProdData.transactionAmount.replace(/,/g, '')) > 400000) {
          navigate('/LIPayment/LifePaymentUpload', {
            state: {
              paymentType: obj.paymentType ?? '',
              requestPart: obj,
              policyNumber: obj.policyNumber,
              message: 'life.Payment.fpsproof1',
            },
          });
        } else {
          if (payProdData.isHighRisk) {
            navigate('/LIPayment/LifePaymentUpload', {
              state: {
                paymentType: obj.paymentType ?? '',
                requestPart: obj,
                policyNumber: obj.policyNumber,
                message: 'life.Payment.fpsproof2',
              },
            });
          } else {
            navigate(
              { pathname: '/LIPayment/CreditCardSuccess' },
              {
                state: successState,
              },
            );
          }
        }
      } else if (payProdData.paymentMethod == 'credit_card') {
        console.log('8888888888888888888888888888888888888888');
        if (Number(payProdData.transactionAmount.replace(/,/g, '')) > 400000) {
          navigate('/LIPayment/LifePaymentUpload', {
            state: {
              paymentType: obj.paymentType ?? '',
              requestPart: obj,
              policyNumber: obj.policyNumber,
              message: 'life.Payment.creditproof',
            },
          });
        } else {
          navigate(
            { pathname: '/LIPayment/CreditCardSuccess' },
            {
              state: successState,
            },
          );
        }
      } else if (
        payProdData.paymentMethod == 'apple_pay' ||
        payProdData.paymentMethod == 'samsung_pay' ||
        payProdData.paymentMethod == 'google_pay'
      ) {
        if (Number(payProdData.transactionAmount.replace(/,/g, '')) > 400000) {
          navigate('/LIPayment/LifePaymentUpload', {
            state: {
              paymentType: obj.paymentType ?? '',
              requestPart: obj,
              policyNumber: obj.policyNumber,
              message: 'life.Payment.eWallet1',
            },
          });
        } else {
          if (payProdData.isHighRisk) {
            navigate('/LIPayment/LifePaymentUpload', {
              state: {
                paymentType: obj.paymentType ?? '',
                requestPart: obj,
                policyNumber: obj.policyNumber,
                message: 'life.Payment.eWallet2',
              },
            });
          } else {
            navigate(
              { pathname: '/LIPayment/CreditCardSuccess' },
              {
                state: successState,
              },
            );
          }
        }
      } else {
        navigate(
          { pathname: '/LIPayment/CreditCardSuccess' },
          {
            state: successState,
          },
        );
      }
    }
    // if (error) {
    //   navigate('/LIPayment/LifePaymentUpload', {
    //     state: {
    //       paymentType: '',
    //       requestPart: obj,
    //       policyNumber: '98041568',
    //       message: 'life.Payment.eWallet2',
    //     },
    //   });
    // }
  }, [payProdData, successState, obj, navigate, t]);

  // useEffect(() => {
  //   navigate &&
  //     successState &&
  //     (over4 && obj
  //       ? navigate('/LIPayment/LifePaymentUpload', {
  //           state: { paymentType: obj.paymentType ?? '', requestPart: obj, policyNumber: obj.policyNumber },
  //         })
  //       : navigate(
  //           { pathname: '/LIPayment/CreditCardSuccess' },
  //           {
  //             state: successState,
  //           },
  //         ));
  // }, [navigate, successState, obj, over4]);
  useEffect(() => {
    return () => {
      sessionStorageService.remove('over4');
      sessionStorageService.remove('uploadData');
    };
  }, []);
  return <Spinner />;
};
